import { useMemo } from 'react';

import { useGetOrganizationsInfo } from '~hooks/queries/organizations/query';
import useGetIntegratedScrapeStatus from '~hooks/queries/scraping/useGetIntegratedScrapeStatus';
import { useGetSettings } from '~hooks/queries/setting/query';
import { useCompanyId } from '~hooks/useCompanyId';
import useIsDemoTrial from '~hooks/useIsDemoTrial';

const BANNER_HEIGHT = 44;
const BANNER_GAP = 8;
const BANNER_MARGIN = 16;

export const useBannerStatus = () => {
  const { companyId } = useCompanyId();
  const isDemoTrial = useIsDemoTrial();

  const { data: organizationsInfo } = useGetOrganizationsInfo();
  const { data: settings } = useGetSettings();

  // overallStatus만 select하여 불필요한 리렌더링 방지
  const { data: isAnalysisInprogress } = useGetIntegratedScrapeStatus(companyId as string, {
    select: (data) => data?.Data?.data?.overallStatus === 'IN_PROGRESS',
  });

  const bankRegistered = organizationsInfo?.Data?.data?.banks?.some((bank) => bank.connected);
  const homeTaxRegistered = organizationsInfo?.Data?.data?.homeTax?.connected;
  const pendingMandateRequest = useMemo(
    () => settings?.Data?.data?.pendingMandateRequest,
    [settings],
  );

  const isShowAlertBanner = useMemo(
    () => isDemoTrial || !bankRegistered || !homeTaxRegistered || isAnalysisInprogress,
    [isDemoTrial, bankRegistered, homeTaxRegistered, isAnalysisInprogress],
  );

  const isExistBanner = useMemo(
    () => isShowAlertBanner || pendingMandateRequest,
    [isShowAlertBanner, pendingMandateRequest],
  );

  const bannerHeight = useMemo(
    () =>
      isShowAlertBanner && pendingMandateRequest
        ? BANNER_HEIGHT * 2 + BANNER_GAP + BANNER_MARGIN
        : isShowAlertBanner || pendingMandateRequest
          ? BANNER_HEIGHT + BANNER_MARGIN
          : 0,
    [isShowAlertBanner, pendingMandateRequest],
  );

  return useMemo(
    () => ({ bannerHeight, isShowAlertBanner, pendingMandateRequest, isExistBanner }),
    [bannerHeight, isShowAlertBanner, pendingMandateRequest, isExistBanner],
  );
};
